import { useRouter } from 'next/router';
// Types
import { UserRole } from 'api/graphql-global-types';
// Constants
import { DASHBOARD } from 'constants/routes';
// Helpers
import { setFullOnboardingLocalStorageFlag } from 'helpers/storage';
// Hooks
import { useAppContext, useGetCurrUser, useOnboardingContext } from 'hooks';

export const useJoinAsTalent = (): (() => void) => {
  const { push } = useRouter();
  const { setSignUpModalVisibility, setSignUpStep } = useAppContext();
  const { setShowOnboardingModal, setFullOnboarding } = useOnboardingContext();
  const { data } = useGetCurrUser();

  return () => {
    if (data?.me?.id) {
      if (data.me.role === UserRole.Customer) {
        setShowOnboardingModal(true);
      } else {
        push(DASHBOARD);
      }
      return;
    }

    setSignUpStep(0);
    setSignUpModalVisibility(true);
    setFullOnboarding(true);
    // Social sign up leaves the page, so the flag has to survive the redirect
    setFullOnboardingLocalStorageFlag('true');
  };
};
